import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1226cd29"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-x4 xl:mb-x6 last:mb-0" }
const _hoisted_2 = { class: "flex items-center mb-x1" }
const _hoisted_3 = { class: "text-20 xl:text-24" }
const _hoisted_4 = {
  key: 0,
  class: "price-splash price-splash--favorite"
}
const _hoisted_5 = {
  key: 1,
  class: "price-splash"
}

import { MaterialModel } from '@/types/productServerApi';
import SearchResultMaterialDetails
    from '@/shared/product/customizer/ui/overlays/material-and-color/SearchResultMaterialDetails.vue';
import SearchResultMaterialVariants
    from '@/shared/product/customizer/ui/overlays/material-and-color/SearchResultMaterialVariants.vue';
import SearchResultMaterialPrice
    from '@/shared/product/customizer/ui/overlays/material-and-color/SearchResultMaterialPrice.vue';
import { computed } from 'vue';
import useMaterialAndColor from '@/shared/product/customizer/ui/overlays/material-and-color/useMaterialAndColor';
import useProductDetailData from '@/shared/product/details/useProductDetailData';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResultMaterial',
  props: {
    material: null
  },
  setup(__props: any) {

const props = __props as {
    material: MaterialModel,
}




const labels = useBlockLabels();
const { getSelectedPriceFromVariants, getFilteredVariants, getSelectedSkuFromVariants } = useMaterialAndColor();
const { variantId } = useProductDetailData();

const price = computed(() => getSelectedPriceFromVariants(props.material.variantWithPrices));
const materialVariantId = computed(() => getSelectedSkuFromVariants(props.material.variantWithPrices));

const filteredVariants = computed(() => getFilteredVariants(props.material.variantWithPrices));

const isSelectedMaterial = computed(() => {
    const sku = variantId.value;
    return props.material.variantWithPrices.find((variant) => variant.sku === sku) !== undefined;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(__props.material.name), 1),
      (__props.material.isBestSeller)
        ? (_openBlock(), _createElementBlock("em", _hoisted_4, _toDisplayString(_unref(labels).overlayMaterialBestsellerSplash), 1))
        : _createCommentVNode("", true),
      (_unref(isSelectedMaterial))
        ? (_openBlock(), _createElementBlock("em", _hoisted_5, _toDisplayString(_unref(labels).overlayMaterialSelectedSplash), 1))
        : _createCommentVNode("", true)
    ]),
    (_unref(price))
      ? (_openBlock(), _createBlock(SearchResultMaterialPrice, {
          key: 0,
          price: _unref(price),
          "variant-id": _unref(materialVariantId),
          class: "mb-x1"
        }, null, 8, ["price", "variant-id"]))
      : _createCommentVNode("", true),
    _createVNode(SearchResultMaterialDetails, {
      cover: __props.material.materialCover,
      tests: __props.material.fabricTests,
      certificates: __props.material.fabricCertificates
    }, null, 8, ["cover", "tests", "certificates"]),
    _createVNode(SearchResultMaterialVariants, { variants: _unref(filteredVariants) }, null, 8, ["variants"])
  ]))
}
}

})